import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-input-wrapper ant-input-group ss-alinhar-texto-direita"
}
const _hoisted_2 = ["value", "title", "data-coluna", "disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon" }, "CM", -1)
const _hoisted_4 = {
  key: 1,
  class: "ant-input-wrapper ant-input-group ss-alinhar-texto-direita"
}
const _hoisted_5 = ["value", "title", "data-coluna", "disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon" }, "KG", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.props.centimetro)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("input", {
          ref: "refCampoNumerico",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.change())),
          onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validarInformacaoDigitada($event))),
          onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.valorDigitado($event))),
          onKeydown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.valorDigitado($event))),
          type: "text",
          onPaste: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validarInformacaoColada($event))),
          class: _normalizeClass('ant-input ' + _ctx.props.classCss),
          value: _ctx.apresentaValorMascarado(),
          onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.digitandoValor($event))),
          title: _ctx.props.title,
          "data-coluna": _ctx.props.dataAttributeColuna,
          disabled: _ctx.props.disabled,
          onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.inputFocus($event))),
          onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.blur()))
        }, null, 42, _hoisted_2),
        _hoisted_3
      ]))
    : (_ctx.props.peso)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createElementVNode("input", {
            ref: "refCampoNumerico",
            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.change())),
            onKeypress: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validarInformacaoDigitada($event))),
            onKeyup: _cache[10] || (_cache[10] = ($event: any) => (_ctx.valorDigitado($event))),
            onKeydown: _cache[11] || (_cache[11] = ($event: any) => (_ctx.valorDigitado($event))),
            type: "text",
            onPaste: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validarInformacaoColada($event))),
            class: _normalizeClass('ant-input ' + _ctx.props.classCss),
            value: _ctx.apresentaValorMascarado(),
            onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.digitandoValor($event))),
            title: _ctx.props.title,
            "data-coluna": _ctx.props.dataAttributeColuna,
            disabled: _ctx.props.disabled,
            onFocus: _cache[14] || (_cache[14] = ($event: any) => (_ctx.inputFocus($event))),
            onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.blur()))
          }, null, 42, _hoisted_5),
          _hoisted_6
        ]))
      : _createCommentVNode("", true)
}